import React, { useState, useRef, useEffect, useContext } from "react";
import { assetUrl } from "../../../Utils/assetUrl";
import Lottie from "lottie-web";
import AuthContext from "../../../context/userAuth.context";

const CharacterLoader = ({
  setLoadCounter,
  value,
  ticker,
  TickerRef,
  player,
  AnimationId,
  isAnimatedText,
  CanvasDisplay,
  onePxEquivalent,
  SlidesData,
}) => {
  const [CanvChar, setCanvChar] = useState(null);

  const refnew = useRef();

  const [chechState, setchechState] = useState(true);
  const [LoopComplete, setLoopComplete] = useState(false);
  const [CurrentFrame, setCurrentFrame] = useState(0);
  const { authenticationData } = useContext(AuthContext);

  useEffect(() => {
    if (CanvChar) {
      if (sessionStorage.getItem("LoadCounter")) {
        let array = JSON.parse(sessionStorage.getItem("LoadCounter"));
        array.push(value.previewKey);
        sessionStorage.setItem("LoadCounter", JSON.stringify(array));
        setLoadCounter(array);
      }
    }
  }, [CanvChar]);

  //boss ye dekho asal me iski base per chlna chahye ticker
  // useEffect(() => {
  //     console.log(TickerRef.current.value)
  // }, [TickerRef.current.value]);

  useEffect(() => {
    if (CanvChar != null) {
      if (
        value.startPositionOnTimeline + 0 < TickerRef.current.value &&
        value.startPositionOnTimeline + value.widthOnTimeline >
          TickerRef.current.value
      ) {
        //console.log("Ticker",TickerRef.current.value);
        let playedtime =
          TickerRef.current.value - value.startPositionOnTimeline; //in px
        let jsonTotaltime = CanvChar.totalFrames;
        let fm = CanvChar.frameRate;
        let ms = (playedtime * onePxEquivalent) / 1000;
        let playedFrame = ms * fm;
        let Playon = null;

        if (playedFrame > jsonTotaltime) {
          while (true) {
            let start = playedFrame - jsonTotaltime;
            if (start < jsonTotaltime) {
              Playon = start;
              break;
            } else {
              playedFrame = start;
            }
          }
        } else {
          Playon = playedFrame;
        }
        CanvChar.goToAndStop(Playon, true, AnimationId);
        setCurrentFrame(Playon);
        if (!LoopComplete) {
          setLoopComplete(true);
        }
      }
      if (value.startPositionOnTimeline > TickerRef.current.value) {
        CanvChar.goToAndStop(0, true, AnimationId);
        setCurrentFrame(0);
        if (!LoopComplete) {
          setLoopComplete(true);
        }
      }
    }
  }, [TickerRef.current.value]);

  useEffect(async () => {
    if (value.character_FilePath != undefined) {
      if (!value.JSONValue) {
        const resp = await fetch(
          assetUrl(authenticationData.ApiBaseURL, value.character_FilePath)
        );
        value.JSONValue = await resp.json();
      }

      if (isAnimatedText) {
        if (value.DrapEndAnimatedText) {
          if (CanvChar) CanvChar.goToAndStop(CanvChar.totalFrames - 200, true);
        } else if (value.endTimeOfAnimatedText) {
          if (value.speedOn) {
            if (CanvChar) CanvChar.setSpeed(2.5);
          } else if (value.fastspeedOn) {
            if (CanvChar) CanvChar.setSpeed(3);
          }

          if (CanvChar)
            CanvChar.playSegments(
              [value.playSegmentFrom, value.playSegmentTo],
              true
            );
          value.endTimeOfAnimatedText = false;
        } else if (value.startTimeOnTimeline) {
          if (CanvChar) CanvChar.pause(value.AnimationId);
          value.startTimeOnTimeline = false;
        } else if (value.LoadLottie) {
          const data = Lottie.getRegisteredAnimations();
          for (let i = 0; i < data.length; i++) {
            if (data[i].name == value.AnimationId) {
              Lottie.destroy(value.AnimationId);
              setCanvChar(null);
            }
          }
          const get = Lottie.loadAnimation({
            container: refnew.current,
            name: value.AnimationId,
            renderer: "svg",
            loop: true,
            autoplay: true,
            animationData: value.JSONValue,
            rendererSettings: {
              preserveAspectRatio: "xMidYMin slice",
              viewBoxOnly: true,
              progressiveLoad: true,
            },
          });

          get.addEventListener("loopComplete", async function () {
            get.goToAndStop(get.totalFrames - 50, true);

            // get.playSegments([370, 600], true)
            setLoopComplete(true);
            get.removeEventListener("loopComplete");
          });

          setCanvChar(get);
          setchechState(true);

          value.LoadLottie = false;
        }
      } else {
        if (value.isStartTalking === true) {
          const data = Lottie.getRegisteredAnimations();
          for (let i = 0; i < data.length; i++) {
            if (data[i].name == AnimationId) {
              Lottie.destroy(AnimationId);
              setCanvChar(null);
            }
            if(data[i].name== AnimationId.replace('inPreview',''))
            {
              Lottie.destroy(data[i].name);
              setCanvChar(null);
            }
          }

          value.isStartTalking = false;
          value.isHide = false;
          const get = Lottie.loadAnimation({
            container: refnew.current,
            name: AnimationId,
            renderer: "svg",
            loop: true,
            autoplay: chechState,
            animationData: value.JSONValue,
            rendererSettings: {
              preserveAspectRatio: "xMidYMin slice",
              viewBoxOnly: true,
              progressiveLoad: true,
            },
          });

          let playedtime = ticker - value.startPositionOnTimeline; //in px
          let jsonTotaltime = get.totalFrames;
          let fm = get.frameRate;
          let ms = (playedtime * onePxEquivalent) / 1000;
          let playedFrame = ms * fm;
          let Playon = null;

          if (playedFrame > jsonTotaltime) {
            while (true) {
              let start = playedFrame - jsonTotaltime;
              if (start < jsonTotaltime) {
                Playon = start;
                break;
              } else {
                playedFrame = start;
              }
            }
          } else {
            Playon = playedFrame;
          }

          setCanvChar(get);
          setchechState(true);
          get.goToAndPlay(Playon, true);
        } else if (value.isStopTalking === true) {
          const data = Lottie.getRegisteredAnimations();
          for (let i = 0; i < data.length; i++) {
            if (data[i].name == AnimationId) {
              Lottie.destroy(AnimationId);
              setCanvChar(null);
            }
            if(data[i].name== AnimationId.replace('inPreview',''))
            {
              Lottie.destroy(data[i].name);
              setCanvChar(null);
            }
          }

          value.isHide = false;
          value.isStopTalking = false;
          const get = Lottie.loadAnimation({
            container: refnew.current,
            name: AnimationId,
            renderer: "svg",
            loop: true,
            autoplay: chechState,
            animationData: value.JSONValue,
            rendererSettings: {
              preserveAspectRatio: "xMidYMin slice",
              viewBoxOnly: true,
              progressiveLoad: true,
            },
          });
          let playedtime = ticker - value.startPositionOnTimeline; //in px
          let jsonTotaltime = get.totalFrames;
          let fm = get.frameRate;
          let ms = (playedtime * onePxEquivalent) / 1000;
          let playedFrame = ms * fm;
          let Playon = null;

          if (playedFrame > jsonTotaltime) {
            while (true) {
              let start = playedFrame - jsonTotaltime;
              if (start < jsonTotaltime) {
                Playon = start;
                break;
              } else {
                playedFrame = start;
              }
            }
          } else {
            Playon = playedFrame;
          }

          setCanvChar(get);
          setchechState(true);
          get.goToAndPlay(Playon, true);
        } else if (value.isStartTalking === undefined) {
          const data = Lottie.getRegisteredAnimations();
          for (let i = 0; i < data.length; i++) {
            if (data[i].name == AnimationId) {
              Lottie.destroy(AnimationId);
              setCanvChar(null);
            }
            if(data[i].name== AnimationId.replace('inPreview',''))
            {
              Lottie.destroy(data[i].name);
              setCanvChar(null);
            }
          }
          value.isStartTalking = false;
          await stopTalking(value.JSONValue);
          const get = Lottie.loadAnimation({
            container: refnew.current,
            name: AnimationId,
            renderer: "svg",
            loop: true,
            autoplay: chechState,
            animationData: value.JSONValue,
            rendererSettings: {
              preserveAspectRatio: "xMidYMin slice",
              viewBoxOnly: true,
              progressiveLoad: true,
            },
          });

          //get.goToAndStop(0, true);
          setCanvChar(get);
          setchechState(false);

          get.goToAndStop(0, true);
          // setTimeout(() => {
          //     get.goToAndPlay(0, true);
          // }, 1200);
        }
      }
    }
  }, [SlidesData]);

  const stopTalking = async (jsondata) => {
    const _jsonData = jsondata.assets[1].layers;
    const _jsonData2 = jsondata.assets[0].layers;
    const _jsonData3 = jsondata.layers[0].layers;

    if (_jsonData) {
      for (let i = 0; i <= _jsonData.length - 1; i++) {
        if (_jsonData[i].nm === "Mouth_Talk") {
          _jsonData[i].hd = true;
        } else if (_jsonData[i].nm === "Mouth_Static") {
          _jsonData[i].hd = false;
        }
      }
    }

    if (_jsonData2) {
      for (let i = 0; i <= _jsonData2.length - 1; i++) {
        if (
          (_jsonData2[i].nm == "Mouth" || _jsonData2[i].nm == "mouth") &&
          _jsonData2[i].layers
        ) {
          for (let j = 0; j <= _jsonData2[i].layers.length - 1; j++) {
            if (_jsonData2[i].layers[j].nm === "Mouth_Talk") {
              _jsonData2[i].layers[j].hd = true;
            } else if (_jsonData2[i].layers[j].nm === "Mouth_Static") {
              _jsonData2[i].layers[j].hd = false;
            }
          }
        }
      }
    }

    if (_jsonData3) {
      for (let i = 0; i < _jsonData3.length - 1; i++) {
        if (
          (_jsonData3[i].nm === "Mouth" || _jsonData3[i].nm === "mouth") &&
          _jsonData3[i].layers
        ) {
          for (let j = 0; j <= _jsonData3[i].layers.length - 1; j++) {
            if (_jsonData3[i].layers[j].nm === "Mouth_Talk") {
              _jsonData3[i].layers[j].hd = true;
            } else if (_jsonData3[i].layers[j].nm === "Mouth_Static") {
              _jsonData3[i].layers[j].hd = false;
            }
          }
        }
      }
    }
  };

  useEffect(() => {
    if (CanvasDisplay) {
      if (!chechState) {
        CanvChar.stop(AnimationId);
      }
    }
  }, [CanvasDisplay]);

  useEffect(() => {
    console.log("updating player");
    if (player) {
      if (!chechState) {
        CanvChar.goToAndPlay(CurrentFrame, true, AnimationId);
        if (!LoopComplete) {
          setLoopComplete(true);
        }
      }
    } else if (!player) {
      if (!chechState) {
        CanvChar.stop(AnimationId);
      }
    }
  }, [player]);
  const generateTransformClass = () => {
    if (value.flip) {
      if (CanvasDisplay) {
        return "";
      } else {
        return `rotate(${value.rotateAngle}deg)`;
      }
    } else {
      if (CanvasDisplay) {
        return "";
      } else {
        return `rotate(${value.rotateAngle}deg)`;
      }
    }
  };
  return (
    <div
      className={value.Editable == true ? "RectBorder" : ""}
      id={AnimationId}
      style={{
        //transform: generateTransformClass(),
        width: "100%",
        height: "100%",
        position: "absolute",
        top: "0px",
        opacity: value.opacity,
        zIndex: -1,
      }}
    >
      <div ref={refnew} />
    </div>
  );
};
export default CharacterLoader;
